import Axios from "axios";

export const fileUpload = async (payload) => {
    const response = await Axios.post(`api/file/upload-file`, payload);
    return response.data;
};

export const fileDownload = async (containerName, fileName, mimetype) => {

    const res = await Axios.get(`api/file/download-file`, {
        params: { containerName, fileName, mimetype }
    });
    return res.data;
}